<template>
  <div
    v-on:mouseover="
      $set(
        hoverCheck,
        'history-list-' + historyItem.type + '-' + historyItem.id,
        true
      )
    "
    v-on:mouseleave="
      $set(
        hoverCheck,
        'history-list-' + historyItem.type + '-' + historyItem.id,
        false
      )
    "
    v-on:click="showActionEntry({ type: 'note', record: historyItem })"
    v-bind:class="{
      'note-bubble-hover':
        hoverCheck['history-list-' + historyItem.type + '-' + historyItem.id]
    }"
  >
    <div class="note-bubble">
      <div class="msg-bubble-content">
        <div class="no-whitespace">{{ historyItem.note }}</div>
      </div>
    </div>
    <div class="msg-detail-header ml-auto">
      <span>
        <i
          v-bind:class="{
            'ui-icon-hide': !hoverCheck[
              'history-list-' + historyItem.type + '-' + historyItem.id
            ]
          }"
          class="ui-icon write"
        ></i>
      </span>
      <span class="msg-detail-name">{{
        userNameFromHistoryItem(historyItem)
      }}</span>
      <span class="msg-detail-time">{{
        formattedDateTime(historyItem.updatedAt)
      }}</span>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "NoteContentBubble",
  components: {},
  props: {
    historyItem: Object,
    customerName: String,
    showActionEntry: Function,
    hoverCheck: Object
  },
  data: function() {
    return {};
  },
  computed: {},
  created() {},
  watch: {},
  methods: {
    userNameFromHistoryItem(historyItem) {
      return historyItem.user ? historyItem.user.longName : "";
    },
    formattedDateTime(number) {
      return format(new Date(number), "E h:mm a, M/d/y");
    }
  }
};
</script>

<style scoped lang="stylus">
div.note-bubble {
  margin: 0.25rem 1rem;
  width: 100%;
  border-radius: 0.15rem;
  background-color: #ffffdf;
  border: 1px solid #ccc;
  box-shadow: 0.1rem 0.1rem 0.2rem #999;
}

div.note-bubble .msg-bubble-content {
  border: 1px solid #ffffdf;
}
</style>
